import type { ReceiptTemplate } from '../schema';

export const burberryTemplate: ReceiptTemplate = {
  id: 'burberry',
  name: 'Burberry Receipt',
  brand: 'BURBERRY',
  description: 'Luxury fashion receipt template inspired by Burberry stores',
  settings: {
    width: 280,
    font: 'Courier New',
    fontSize: 11,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a2e',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'burberry-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/burberry.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          'Shops at Crystals',
          '3720 S. Las Vegas Blvd Las Vegas',
          'NV 89158',
          '702 560 5022',
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'burberry-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'burberry-trans', label: 'Trans:', value: '14005' },
          { id: 'burberry-date', label: 'Date:', value: '9/30/2025' },
          { id: 'burberry-store', label: 'Store:', value: '4068' },
          { id: 'burberry-sales', label: 'Salesperson:', value: '50126686' },
          { id: 'burberry-cashier', label: 'Cashier:', value: '50126686' },
          { id: 'burberry-customer', label: 'Customer:', value: '400010142184' },
        ],
        column2: [
          { id: 'burberry-reg', label: 'Register:', value: '1' },
          { id: 'burberry-time', label: 'Time:', value: '11:06 AM' },
        ],
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'burberry-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: false,
        quantityPosition: 'left',
        showHeader: true,
        showHeaderDivider: true,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item:',
          amount: 'Amount:',
        },
        items: [
          { id: 'burberry-item-1', name: 'Eyewear 40816801', price: '$560.00' },
        ],
        showTopDivider: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'burberry-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'burberry-subtotal', label: 'Subtotal', value: '560.00', isBold: false, isLarge: false },
          { id: 'burberry-tax', label: 'Tax', value: '46.90', isBold: false, isLarge: false },
          { id: 'burberry-total', label: 'Total', value: '606.90', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 30,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'burberry-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'burberry-card', label: 'Card number', value: '**** **** **** 4922' },
          { id: 'burberry-type', label: 'Card type', value: 'Debit' },
          { id: 'burberry-entry', label: 'Card entry', value: 'Chip' },
          { id: 'burberry-pdate', label: 'Date/time', value: '11/20/2019 11:09 AM' },
          { id: 'burberry-ref', label: 'Reference #', value: '62845289260246240685C' },
          { id: 'burberry-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [
          { id: 'burberry-cash', label: 'Cash', value: '$700.00' },
          { id: 'burberry-change', label: 'Change', value: '$93.10' },
        ],
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'burberry-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Please keep this receipt as proof of purchase. Returns of full-price items are accepted within 30 days, and sale items within 14 days. Items must be unused, in original condition, with all tags attached. Personalized, pierced, or fragrance items are non-returnable. Refunds are issued to the original payment method. Exchanges are not available; please return and place a new order.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};
